import { NumberInput } from '@mantine/core';

export default NumberInput.extend({
	defaultProps: {
		size: 'xs'
	}
});
